import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { useUser } from '@/features/auth/hooks/use-user';
import { getUserOrgs } from '@/features/org/api/get-user-orgs';
import { Org } from '@/shared/types/api';

interface Props extends UseQueryOptions<Org[], unknown, Org[]> {
  userId: string;
}

export const getUserOrgsQueryKey = (userId?: string) => ['orgs', userId];

export const useUserOrgs = (props?: Props) => {
  const { data: user } = useUser();
  return useQuery({
    ...props,
    queryKey: getUserOrgsQueryKey(user?.id),
    queryFn: async () => {
      const orgs = await getUserOrgs();
      return orgs;
    },
    enabled: !!user,
  });
};
